import apiClient from '@/services/api-client';

export default {
	getAllDripCampaigns(contactId, entityId) {
		return apiClient().post('/DripCampaigns/GetAllByContactIdEntityId', {
			contactId,
			entityId,
		});
	},
	getDripCampaignById(dripCampaignId) {
		return apiClient().post('/DripCampaigns/GetDripCampaignById', {
			dripCampaignId: dripCampaignId,
		});
	},
	getCampaignSettings(ids) {
		return apiClient().post('/DripCampaigns/GetDripCampaignSettings', ids);
	},
	saveCampaignSetting(settingsInfo) {
		return apiClient().post(
			'/DripCampaigns/SaveDripCampaignSetting',
			settingsInfo,
		);
	},
	getAllDripCampaignContactStatuses(dripCampaignId) {
		return apiClient().post('/DripCampaigns/GetAllStatuses', {
			dripCampaignId,
		});
	},
};
